import { render, staticRenderFns } from "./ModuleHistory.vue?vue&type=template&id=473577c4"
import script from "./ModuleHistory.vue?vue&type=script&lang=js"
export * from "./ModuleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports